// Copyright Epic Games, Inc. All Rights Reserved.

import { useDispatch, useSelector } from "react-redux";
import {
  selectInstallationCancelling,
  selectInstallationErrorCode,
  selectInstallationGroupProgress,
  selectInstallationProgress,
  selectInstallationPulledMetadataFlag,
} from "./selectors";
import {
  IInstallationGroupProgressMessage,
  IInstallationProgress,
} from "../../services/EOSHelperAPI";
import { cancelInstallation } from "./actions";

export const useInstallationProgress = (): IInstallationProgress =>
  useSelector(selectInstallationProgress);

export const useInstallationGroupProgress = (): IInstallationGroupProgressMessage =>
  useSelector(selectInstallationGroupProgress);

export const useCancellingInstallationFlag = (): boolean =>
  useSelector(selectInstallationCancelling);

export const useInstallationErrorCode = (): string | undefined =>
  useSelector(selectInstallationErrorCode);

export const useCancelInstallationDispatchAction = (): (() => void) => {
  const dispatch = useDispatch();

  return () => dispatch(cancelInstallation());
};

export const useInstallationPulledMetadataFlag = (): boolean => {
  return useSelector(selectInstallationPulledMetadataFlag);
};
